import { mapKeys } from 'lodash'
import queryString from 'query-string'

import { OrderListFilters } from './types'

const FILTER_KEYS_WITHOUT_FORMAT = ['page', 'perPage', 'search', 'mode']

export function prepareOrderListQuery(filter: OrderListFilters) {
  const filterWithFormatKeys = mapKeys(filter, (v, k) => {
    if (FILTER_KEYS_WITHOUT_FORMAT.includes(k)) {
      return k
    }

    return `filter[${k}]`
  })

  return queryString.stringify(filterWithFormatKeys, { arrayFormat: 'bracket' })
}

export function prepareOrderSearchQuery(filter: OrderListFilters) {
  const { page, perPage, search, ...rest } = filter
  const query: Record<string, any> = {}

  if (page !== undefined) {
    query.page = page
  }
  if (perPage !== undefined) {
    query.perPage = perPage
  }
  if (search) {
    query['filter[number]'] = search
  }

  return queryString.stringify(query, { arrayFormat: 'bracket' })
}
